import * as React from "react";

import {
  Box,
  Slide,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmPopup({
  open,
  handleClose,
  message,
  id,
  index,
}) {
  const { t } = useTranslation("common");
  const [openPopup, setOpen] = React.useState(false);

  return (
    <Box color="default">
      <Dialog
        open={open}
        onBackdropClick={() => handleClose(false)}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose(false)}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "#1E1E1E",
            boxShadow: "none",
            color: "#ffffff",
            borderRadius: 16,
            padding: 16,
          },
        }}
      >
        <DialogContent>
          <DialogContentText
            color="default"
            align="center"
            id="alert-dialog-slide-description"
          >
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            style={{ width: "50%", padding: "10px 45px !important" }}
            sx={{ backgroundColor: "#1E1E1E" }}
            onClick={() => handleClose(false)}
            color="default"
          >
            {t("confirmPopup.button1")}
          </Button>
          <Button
            style={{ width: "50%", padding: "10px 45px !important" }}
            variant="contained"
            color="primary"
            onClick={() => handleClose(true, id, index)}
          >
            {t("confirmPopup.button2")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
